import React, { useEffect } from 'react';
import Swiper from 'swiper';
import api from '../plugin/api.js';
import "../Assets/js/testjsxfunction.js";
import "../Assets/js/generalui.js";

import GoogleLogin from '../components/GoogleLogin.jsx';

// import { Player } from '@lottiefiles/react-lottie-player';
// import { createRoot } from 'react-dom/client';


import '../Assets/css/testcss.css'
import  '../Assets/js/testscript.js'

// import {
//   initAuthListener,
//   loginWithGoogle,
//   logout,
//   getToken,
//   getCurrentUser,
//   deleteAccount,
//   initAuthSystem
// } from '../plugin/firebase';

import {
  initAuth,
  loginauthservice,
  logoutauthservice,
  deleteAccount,
  getSession,
  getToken,
  getUser
} from "../plugin/authService.js";


function TestInfiniteScroll()
{
  const loadBooking = async (uuid) =>
  {
    const res = await fetch(`https://beta.api.pingingo.com/v2/bookings/${uuid}`,
    {
      method: "GET",
      credentials: "include",
      headers:
      {
        "Accept": "application/json",
        "Origin": "https://pingingo.com",
        "x-access-key":"faf2bf0b-162b-4ba5-9a6d-8160375ad48d"
      }
    });

    return res.json();
  };

  const LoadBanner = async () =>
  {
    const res = await fetch("https://beta.api.pingingo.com/v2/banners/pop-up",
    {
      method: "GET",
      credentials: "include",
      headers:
      {
        "Accept": "application/json",
        "x-api-key":"J0NR30CRoDIa2VtwmUeTxHCH1jlQK3sQ"
      }
    });

    return res.json();
  };

  useEffect(() =>
  {
    // window.loadBooking = loadBooking;
    // window.LoadBanner = LoadBanner;
    window.PrepareTestInstantiate();
    document.getElementById("IdTransactionInput").value = "f8739240-35d8-49e3-9bbc-fd58549c7559";
    window.TestFunction();
    // api.get("/access/bookings/83090476-eac8-11f0-b9a9-2047479213e0")
    // .then(res => {
    //   console.log(res);
      
    // })
    // .catch(err => {
    //   console.error(err);
    // });

    // api.get("/access/debug-headers")
    // .then(res => {
    //   console.log(res);
      
    // })
    // .catch(err => {
    //   console.error(err);
    // });

    // ================ FIRE BASE RELATED ==========================

    // initAuthListener((data) =>
    // {
    //   console.log("FULL AUTH DATA:", data);
    //   console.log(getCurrentUser()); 

    // });

    // initAuthSystem((data) =>
    // {
    //   if (!data) {
    //     // not logged in
    //     return;
    //   }

    //   console.log("Firebase user:", data.sessionUser);
    //   console.log("Backend user:", data.backendUser);
    //   console.log("Token:", data.token);
    // });

    var swiper = new window.Swiper(".mySwiper",
    {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: true, // Optional: enables scroll wheel navigation
    });



  }, []);

  return (
    <div className="container">
        <div className="Navbar">
            <button className="BackButton">←</button>
            <span id="NavbarTitle"></span>
        </div>

        <div className="Banner">
            Hotel Images
        </div>

        <div id="HotelTitle" className="HotelTitle">
            <h2>D'Limasan Cottage</h2>
            <p>Uluwatu, Bali</p>
        </div>

        <div className="Section">
            <h3>Facilities</h3>
            <p>Lorem ipsum...</p>
        </div>

        <div className="Section">
            <h3>Description</h3>
            <p>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
            </p>
        </div>

        <div id="BookingSection" className="BookingSection">
            <h3>Pilih Kamar</h3>
            <button>Ubah</button>
        </div>

        <div className="Section">
            <h3>Rooms</h3>

            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
        </div>

        <div className="swiper mySwiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">Slide 1</div>
            <div className="swiper-slide">Slide 2</div>
            <div className="swiper-slide">Slide 3</div>
          </div>
        </div>


        <div id="StickyBookingBar" className="StickyBookingBar">
            <strong>Pilih Kamar</strong>

            <button>Ubah</button>
        </div>

        <script src="script.js"></script>

        <h1>Test Page</h1>
        <div className="swiper hotelSwiper" id='SampleHotelSwiper'>
          <div className="swiper-wrapper"></div>
        </div>
        <div>
          <h1>Login</h1>
          <div>
            <button onClick={() => loginauthservice("google", null, null)}>Login with Google</button>

            <button onClick={() => loginauthservice("pingingo",{
              email: "yosiadanielo@gmail.com",
              password: "Test@123"
            }, null)}>
              Login with Email
            </button>
          </div>
          <div>
            <button onClick={logoutauthservice}>
              Logout
            </button>

            <button onClick={deleteAccount} style={{ color: "red" }}>
              Delete Account
            </button>
          </div>
        </div>
        <div style={{backgroundColor:"grey", padding:"20px", width:"500px"}}>
            <p>Test Send Email</p>
            <input type="text" id="IdTransactionInput" style={{width:"90%"}} />
            <button onClick={()=>window.TestSendEmailTemplate('waiting')}>Send Waiting Payment</button>
            <button onClick={()=>window.TestSendEmailTemplate('success')}>Send Success</button>
            <button onClick={()=>window.TestSendEmailTemplate('timeout')}>Send Timeout</button>
            <button onClick={()=>window.TestSendEmailTemplate('BookingConfirmed')}>Booking Confirmed</button>
            <button onClick={()=>window.TestSendEmailTemplate('BookingCompleted')}>Booking Completed</button>
        </div>
        <div id="container" className="container"></div>
        
        {/* <dotlottie-wc src="/Assets/images/lottieanim/cross.json" speed="1" style={{width: "300px", height: "300px"}} mode="forward"loopautoplay></dotlottie-wc> */}





        {/* =================================== HOTEL DETAILS PILIH JENIS EXPERIENCE ================================ */}

            <div className="BasicBlackBlocker">
                <div className="FlexFullDisplayPanel" style={{padding:0, overflow:"hidden"}}>
                    <div className="FlexContainerBaseAnimate PingExprezyViewMoreContainer">

                        <div className="TopBottomHeaderButtonPaddingContainer BasicBoxShadow" style={{backgroundColor:"#2494D9"}}>
                            <div className='ColumnGapExtraLong' style={{flex: "1 1 0%", height: "fit-content", display: "flex", position: "relative"}}>
                                <img src="/Assets/images/ButtonIcon/chevron-white.svg" className="BasicInputFieldChevronIconSearch Selectable2" style={{margin:"auto 0", rotate:"90deg"}}/>
                                <p className="PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont" style={{margin: "auto 0", color:"#FFFFFF"}}>Pilih Jenis Experience</p>
                                <img src="/Assets/images/ButtonIcon/x-close.svg" className="CloseButtonInsidePanel Selectable2" style={{position: "absolute", right: "0px", top: "50%", transform: "translateY(-50%)"}}/>
                            </div>
                        </div>

                        <div className="FlexContainerBaseAnimate RowGapBasic2" style={{width:"100%"}}>
                            <div className='TopBottomHeaderButtonPaddingContainer' style={{flexDirection:"column"}}>
                                <div className="HotelDetailsHotelInformationMarginWrapper2">
                                    <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3 SmallMarginList" style={{backgroundColor:"transparent"}}>
                                        <img className="BasicIconInsideInput2" src="/Assets/images/ButtonIcon/calendar-black.svg" style={{ marginLeft: 0 }}/>
                                        <div className="SearchInputFieldTopBottomTextWrapper">
                                            <p className="BasicInputTextTop InterBoldTextFont" style={{ marginTop: 0 }}>Tanggal Berkunjung</p>
                                        </div>
                                        <div className='ColumnGapLong' style={{display:"flex"}}>
                                            <p className="BasicInputTextTop InterRegularTextFont" style={{ color:"#667085"}}>-- ---- ---- -  -- ---- ----</p>
                                            <img src="/Assets/images/ButtonIcon/chevron.svg" className="BasicInputFieldChevronIconSearch ToggleArrow" style={{ rotate: "0deg" }}/>
                                        </div>
                                    </div>

                                    <div className="HoverableContentInsideInputField" style={{flexDirection:"column", backgroundColor:"#FFFAF5"}}>

                                        <div className="SearchTopNonIndexSection" style={{backgroundColor:"transparent"}}>
                                            <img className="BasicIconInsideInput3" src="/Assets/images/ButtonIcon/black-outline-star.svg" style={{ marginLeft: 0 }}/>
                                            <div className="SearchInputFieldTopBottomTextWrapper">
                                                <p className="BasicInputTextTop InterExBoldTextFont" style={{ marginTop: 0 }}>Tipe Experience</p>
                                            </div>
                                            <div style={{position:"relative", display:"flex", flexDirection:"column"}}>
                                                <div className='ColumnGapLong' style={{display:"flex"}}>
                                                    <p className="BasicInputTextTop InterExBoldTextFont" style={{ color:"#1D2939"}}>Tiket Masuk Ciwangun Indah Camp</p>
                                                    <img src="/Assets/images/ButtonIcon/chevron.svg" className="BasicInputFieldChevronIconSearch ToggleArrow" style={{ rotate: "0deg" }}/>
                                                </div>
                                                <div className="ContainerFlex" style={{bottom: "0"}}>
                                                    <div className="DropDownContainer HideScrollBar ShorterHeightDropDown">
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                        <div className="DropDownSelectionContainer DropDownWithStatus">
                                                            {/* <img className="LocationIconInsidePanel BasicMarginLR" src="/Assets/images/ButtonIcon/location-icon.svg" style={{marginLeft:"0px", marginTop:"auto", marginBottom:"auto"}}/> */}
                                                            <p className="DropDownSelectionText">Bali</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="HoverableContentInsideInputField Unselectable" id="CheckOutDateInput" data-date="2" data-month="1" data-year="2000" onClick={() => window.OpenDateChoiceContainer('CheckOutDateInput', 'CheckInDateInput', '', 'End', 'HowManyNightText', 1, false, false, true, false, false, false, null)}>
                                                <div className="SearchTopNonIndexSection BasicInputFieldContainer Selectable3">
                                                    <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{ transform: "scaleX(-1)", marginLeft: 0 }} />
                                                    <div className="SearchInputFieldTopBottomTextWrapper">
                                                        <p className="BasicInputTextTop InterBoldTextFont" id="CheckOutDateInputDateText" style={{ marginTop: 0 }}>02 Jan 2000</p>
                                                        <p className="BasicInputTextBottom InterRegularTextFont" id="CheckOutDateInputDayNameText">Sunday</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>

                                        <div className="SearchTopNonIndexSection" style={{backgroundColor:"transparent"}}>
                                            <div className="SearchInputFieldTopBottomTextWrapper" style={{flexDirection:"row"}}>
                                                <p className="BasicInputTextTop InterBoldTextFont" style={{margin:"auto 0"}}>Tiket Tamu Dewasa</p>
                                                <div className="RoomButtonAndInputContainer">
                                                    <img className="IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity" src="/Assets/images/ButtonIcon/reduce-circle-button.svg"/>
                                                    <div className="SmallPanelDropDownContainer Selectable3">
                                                        <input className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" type="number" placeholder="0"/>
                                                    </div>
                                                    <img className="IncreaseReduceRoomButton Selectable2" id="IncreaseRoomQuotaButton" src="/Assets/images/ButtonIcon/increase-circle-button.svg"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="SearchTopNonIndexSection" style={{backgroundColor:"transparent"}}>
                                            <div className="SearchInputFieldTopBottomTextWrapper" style={{flexDirection:"row"}}>
                                                <p className="BasicInputTextTop InterBoldTextFont" style={{margin:"auto 0"}}>Tiket Tamu Anak-Anak</p>
                                                <div className="RoomButtonAndInputContainer">
                                                    <img className="IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity" src="/Assets/images/ButtonIcon/reduce-circle-button.svg"/>
                                                    <div className="SmallPanelDropDownContainer Selectable3">
                                                        <input className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" type="number" placeholder="0"/>
                                                    </div>
                                                    <img className="IncreaseReduceRoomButton Selectable2" id="IncreaseRoomQuotaButton" src="/Assets/images/ButtonIcon/increase-circle-button.svg"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="SearchTopNonIndexSection" style={{backgroundColor:"transparent"}}>
                                            <div className="SearchInputFieldTopBottomTextWrapper" style={{flexDirection:"row"}}>
                                                <p className="BasicInputTextTop InterBoldTextFont" style={{margin:"auto 0"}}>Tiket Tamu Mancanegara</p>
                                                <div className="RoomButtonAndInputContainer">
                                                    <img className="IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity" src="/Assets/images/ButtonIcon/reduce-circle-button.svg"/>
                                                    <div className="SmallPanelDropDownContainer Selectable3">
                                                        <input className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" type="number" placeholder="0"/>
                                                    </div>
                                                    <img className="IncreaseReduceRoomButton Selectable2" id="IncreaseRoomQuotaButton" src="/Assets/images/ButtonIcon/increase-circle-button.svg"/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="HotelDetailsHotelInformationMarginWrapper" style={{ marginBottom: 0 }}>
                                    <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable" style={{ margin: 0, width: "100%" }}>Simpan</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
    </div>



  )
}

export default TestInfiniteScroll